module.exports = __webpack_public_path__ + "img/sand-decal-30.e4152056.png";